export enum SpConnectChangeTypeEnum {
  ChangeInHeadingSection = 'ChangeInHeadingSection',
  ChangeInDetail = 'ChangeInDetail',
  Reschedule = 'Reschedule',
  NotesOnly = 'NotesOnly',
}
